// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonLoader_container__njzy_","loader":"ButtonLoader_loader__ay2Lc"};